<script setup lang="ts">
import { fetchBooths } from '~/lib/booth';

const name = "課外活動展"

definePageMeta({
  title: "展示・模擬店 - 課外活動展"
})

const { data: booths } = useAsyncData(
  `booths-${name}`,
  () => fetchBooths(name),
  { server: true, lazy: false }
)
</script>

<template>
  <article class="flex flex-col items-center max-w-[900px] mx-auto px-2 py-4">
    <Ribbon class="mb-4 text-md md:text-2xl">
      {{ name }}
    </Ribbon>

    <template v-if="booths !== undefined">
      <div class="grid gap-4 grid-cols-1 md:grid-cols-2 mb-8">
        <template v-for="(booth, i) in booths">
          <BoothItem :data="booth" :index="i" />
        </template>
      </div>
    </template>

    <div class="mb-4">
      <NuxtLink class="btn btn-primary" to="/booth">
        前のページに戻る
      </NuxtLink>
    </div>
  </article>
</template>